import { Component } from "@angular/core";
import { Router } from "@angular/router";


@Component({
    selector: 'app-terms-and-condition',
    templateUrl: './terms-and-condition.component.html',
    styleUrls: ['./terms-and-condition.component.scss']
})

export class TermsAndConditionsComponent{
   public date:string = new Date().toLocaleDateString('en-GB',{
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
   });
    constructor(
        private router: Router
    ){}

    navigate(){
        this.router.navigate(['/privacy-policy']);

    }
}